module.exports = __webpack_public_path__ + "img/dog-mobile.ad7b499a.png";